import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_Label from "../templates/K_Label";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface LabelOptions extends ComponentOptions {
    bindClass?: string;
    hardCodedValue?: string;
    bsc?: string;
    labelWidth?: string | number;
    bindLabel?: string;
    label?: string;
    labelBsc?: string;
    required?: boolean | "true" | "false";
}

export class Label extends TemplateComponent {

    options: LabelOptions;

    constructor(options: LabelOptions) {
        super(K_Label, options);
    }

    preRender() {
        const options = this.options;

        options.bindClass = options.bindClass || "bind-label";
        options.bindValue = buildDataBindSyntax(options.bindValue);
    }

}
